<template>
  <v-menu
    left
    min-width="100px"
    offset-y
    class="the-header-menu"
    content-class="profile-menu"
  >
    <v-btn slot="activator" icon large>
      <v-avatar size="38px">
        <img :src="currentUser.picture" />
      </v-avatar>
    </v-btn>
    <v-list>
      <v-subheader class="subheader-profile">
        {{ currentUser.firstname }} {{ currentUser.lastname }}
      </v-subheader>
      <v-divider />
      <v-list-tile data-tid="logout-btn" class="space-menu-btn" @click="logout">
        <v-list-tile-title>Logout</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    currentUser: {
      type: Object,
      required: true
    },
    logout: {
      type: Function,
      required: true
    }
  }
};
</script>

<style lang="scss">
.profile-menu {
  padding: 0;
  .v-list {
    padding: 0;
  }
}
.subheader-profile {
  cursor: default;
  font-size: 16px;
  font-weight: normal;
}
</style>
